/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReservationSummary } from './ReservationSummary';
import {
    ReservationSummaryFromJSON,
    ReservationSummaryFromJSONTyped,
    ReservationSummaryToJSON,
    ReservationSummaryToJSONTyped,
} from './ReservationSummary';

/**
 * 
 * @export
 * @interface UnprocessedReservationsResponse
 */
export interface UnprocessedReservationsResponse {
    /**
     * 
     * @type {Array<ReservationSummary>}
     * @memberof UnprocessedReservationsResponse
     */
    reservations: Array<ReservationSummary>;
}

/**
 * Check if a given object implements the UnprocessedReservationsResponse interface.
 */
export function instanceOfUnprocessedReservationsResponse(value: object): value is UnprocessedReservationsResponse {
    if (!('reservations' in value) || value['reservations'] === undefined) return false;
    return true;
}

export function UnprocessedReservationsResponseFromJSON(json: any): UnprocessedReservationsResponse {
    return UnprocessedReservationsResponseFromJSONTyped(json, false);
}

export function UnprocessedReservationsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnprocessedReservationsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'reservations': ((json['reservations'] as Array<any>).map(ReservationSummaryFromJSON)),
    };
}

export function UnprocessedReservationsResponseToJSON(json: any): UnprocessedReservationsResponse {
    return UnprocessedReservationsResponseToJSONTyped(json, false);
}

export function UnprocessedReservationsResponseToJSONTyped(value?: UnprocessedReservationsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reservations': ((value['reservations'] as Array<any>).map(ReservationSummaryToJSON)),
    };
}

